import { render, staticRenderFns } from "./compForm.vue?vue&type=template&id=d88833f4&scoped=true&"
import script from "./compForm.vue?vue&type=script&lang=js&"
export * from "./compForm.vue?vue&type=script&lang=js&"
import style0 from "./compForm.vue?vue&type=style&index=0&id=d88833f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88833f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d88833f4')) {
      api.createRecord('d88833f4', component.options)
    } else {
      api.reload('d88833f4', component.options)
    }
    module.hot.accept("./compForm.vue?vue&type=template&id=d88833f4&scoped=true&", function () {
      api.rerender('d88833f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aliApp/businessCooperation/components/compForm.vue"
export default component.exports